import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
import * as EXIF from 'exif-js';
import { Observable, Observer, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Cookies from 'js-cookie';


@Injectable()
export class DocFileService {

    httpReqOptions = {};

    constructor(private http: HttpClient) 
    {
        let self = this;
        self.httpReqOptions = {
            withCredentials: true,
            headers: new HttpHeaders({
              'X-CSRFToken': Cookies.get('csrftoken', {domain: environment.domain, path: environment.path})
            })
        };
    }

    getMediaFileInfo(file: any): Observable<any> 
    {
        let self = this;
        return Observable.create((obs: Observer<any>) => {
            let resp = {lat: "", long: ""};
            if (file) 
            {
                let fileReader = new FileReader();
                fileReader.addEventListener('load', (event: any) => {
                    let exif_data = EXIF.readFromBinaryFile(event.target.result);
                    if (exif_data.hasOwnProperty('GPSLatitude') && exif_data.hasOwnProperty('GPSLongitude')) 
                    { 
                        resp['lat'] = self.getLatitude(exif_data);
                        resp['long'] = self.getLongitude(exif_data);
                    }
                    obs.next(resp);
                });
                fileReader.readAsArrayBuffer(file);
            } else {
                obs.next(resp);
            }
            // obs.complete();
        });
    }

    isGeolocationEnable(element_id: string, file: Blob): Observable<any> 
    {
        return Observable.create((obs: Observer<any>) => {
            let results = {
                    is_geolocation_required: false,
                    lat: "",
                    long: ""
                };
            this.getDocUploadSettings(element_id)
                .subscribe((docUploadSetResp: any) => {
                    if (docUploadSetResp) 
                    {
                        results.is_geolocation_required = docUploadSetResp.is_geolocation_required;
                        this.getMediaFileInfo(file)
                            .subscribe((mediaFileInfoResp: any) => {
                                results.lat = mediaFileInfoResp.lat;
                                results.long = mediaFileInfoResp.long;
                                obs.next(results);
                                obs.complete();
                            });
                    } else {
                        obs.next(results);
                        obs.complete();
                    }
                }, (error) => { 
                    let error_msg = 'Warning: No existing document upload setting for this file upload with ui_id (' + element_id.toString() + ').';
                        error_msg += ' To proceed, you may contact the admin to add to the Document Upload Setting.'
                    alert(error_msg);
                    obs.error(error_msg);
                    obs.complete();
                });
        });
    }

    getDocUploadSettings(param=''): Observable<any> 
    {
        let self = this;
        return this.http.get(environment.apiUrl + 'loan-document-upload-setting/' + param, 
            {
                withCredentials: true,
                headers: new HttpHeaders({
                    'X-CSRFToken': self.getCookie('csrftoken')
                })
            }).map(resps => {
                return resps;
            }).catch(err => {
                throw 'Server Error Details: ' + err.error;
            });
    }

    rewriteAsJpgAndSubmit(file: any): Observable<any> {
        try {
            return Observable.create((obs: Observer<any>) => {
                const reader = new FileReader();
                reader.onload = function(event: any) {
                    const newImg = new Image();
                    newImg.src = '';
                    newImg.onload = function(e) {
                        const canvas = document.createElement('canvas');
                        canvas.width = newImg.width;
                        canvas.height = newImg.height;

                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(newImg, 0, 0);

                        const fileContent = canvas.toDataURL('image/jpeg', 0.5); // 1 - Max Q, 0.5 - Medium Q, 0 - low Q of the jpg compression quality;
                        
                        obs.next(fileContent);
                    }
                    newImg.src = event.target.result;
                }

                if (file) {
                    reader.readAsDataURL(file);
                } else {
                    throw 'file object parameter is undefined.';
                }

            });
        } catch (err) {
            throw 'rewriteAsJpgAndSubmit:Exception => ' + err;
        }
    }

    docFileFormData(form_data: any): FormData {
        let documentData = new FormData();
        documentData.append('doc_file', form_data.doc_file);
        documentData.append('doc_filetype', form_data.doc_filetype);
        documentData.append('description', form_data.description);
        documentData.append('client', form_data.client);
        documentData.append('loan', form_data.loan);
        return documentData;
    }

    getLatitude(data) {
        let self = this;
        var latDeg = data.GPSLatitude[0].numerator;
        var latMin = data.GPSLatitude[1].numerator;
        var latSec = data.GPSLatitude[2];
        var latDir = data.GPSLatitudeRef;

        var latFinal = self.convertDMStoDD(latDeg, latMin, latSec, latDir)
        return latFinal.toFixed(5)
    }

    getLongitude(data) {
        let self = this;
        var longDeg = data.GPSLongitude[0].numerator;
        var longMin = data.GPSLongitude[1].numerator;
        var longSec = data.GPSLongitude[2];
        var longDir = data.GPSLongitudeRef;

        var longFinal = self.convertDMStoDD(longDeg, longMin, longSec, longDir);
        return longFinal.toFixed(5)
    }

    convertDMStoDD(deg, min, sec, dir) {
        var dd = deg + (min/60) + (sec/3600);
        if (dir == 'S' || dir == 'W') {
            dd = dd * -1;
        }
        return dd;
    }

    getCookie(name) {
        return Cookies.get(name, {domain: environment.domain, path: environment.path});
    }

    showErrorMessage(element_name: string) {
        const message = "The image file you have selected has no geolocation information. Make sure your device camera's location setting is on.";
        $(element_name).addClass('is-invalid');
        var err = $('<div class="form-control-feedback text-danger">'+ message +'</div>')
        if($(element_name).parent().find('.form-control-feedback').length == 0) $(element_name).parent().append(err);
        $(element_name).focus();
        $(element_name).val(null);
        $(element_name).val("");
    }

    goToGmap(lat, long): string {
        return 'http://www.google.com/maps/place/' + lat + ','+ long;
    }

    dataUrlToFile(data_url, file_name, file_type): Blob {
        let blobBin = atob(data_url.split(',')[1]);
        let array = [];
        for(let i = 0; i < blobBin.length; i++) {
            array.push(blobBin.charCodeAt(i));
        }
        return new File([new Uint8Array(array)], file_name, {type: file_type});
    }

    createImgLoader(input_elem, display) {
        if ($('.create-img-loader').length && display == 'hide') {
            $('.create-img-loader').remove();
        } else if (display == 'show') {
            let html_loader = '<div class="create-img-loader"><br/>';
                html_loader += '<i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw" style="color: #187ed5ad;"></i>';
                html_loader += '<br/>Processing, Please wait...</div>';
            $(input_elem).after(html_loader);
        }
    }

}



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/service/docfile.service.ts